import { createSelector } from 'reselect';
import { userLoadingSelector } from 'store/state/domainData/selectors';
import {
  isShortlistLoadingSelector,
  isLoadingFavoritesPoisSelector,
  makeShortlistIdsSelector,
  lastViewedListSelector,
  orderedFavoritesListSelector,
  lastContactedListSelector,
} from 'store/state/domainData/selectors/favorites';

export const isShortlistPoiLoadingSelector = createSelector(
  [
    userLoadingSelector,
    isShortlistLoadingSelector,
    isLoadingFavoritesPoisSelector,
  ],
  (userLoading, shortlistLoading, favoritesLoading) =>
    userLoading || shortlistLoading || favoritesLoading
);

export const savedListingListSelector = makeShortlistIdsSelector(orderedFavoritesListSelector);

export const lastViewedPoiIdsSelector = createSelector([
  makeShortlistIdsSelector(lastViewedListSelector),
], lastViewedDatedPoiList => lastViewedDatedPoiList.map(({ poiId }) => poiId.id));

export const lastContactedListingsListSelector = makeShortlistIdsSelector(lastContactedListSelector);
